import React from "react";
import * as actions from '../Actions';
export default function UploadFrame({ eleRef,tool }) {
    return (
        <div className={tool=="MB"?"mybumpie-tag":"face-tag"}>
            { tool=="MB" ?(
                <div>
                <span className="tag-text R15_9e"></span>
                <div className="tag-slider">
                    <div className="M15_42 slide-tag tagkids_1" data-id="1" onClick={(e) => { actions.SlideTag(e,eleRef) }}>
                        <span className="arrow-icon M14_9e" data-icon-font='<' data-id="1" name="myself" id="myself" value="1"></span>
                        Myself
                </div>
                </div>
                <div className="tell_us_more">
                    <input type="text" id="photodesc" className="R15_9e" name="photodesc" placeholder="" maxLength="250" autoComplete="off" />
                    <label className="textfield-label">Tell us more about this pic</label>
                    <br />
                </div>
                </div>):(
                    <div>
                        <div className="tell_us_more">
                        <textarea className="R15_9e" id="photodesc" placeholder="Tell us more about this pic">
                            {eleRef.state.hashTag}
                        </textarea>
                        </div>
                        <span className="tag-text R15_9e">Tag kids present in this face a day</span>
                        <div className="tag-slider">
                        {eleRef.state.childListData && eleRef.state.childListData.length > 0 && eleRef.state.childListData.map((result,index) => result.ChildName==eleRef.state.childName ?
                            (<div key={index} className={"M15_42 slide-tag slide-tag-active tagkids_"+result.ChildId} data-id={result.ChildId} style={{display: "inline-block"}}>
                                <span className="arrow-icon childname M14_9e" id="childname" data-icon-font='<' data-id={result.ChildId}></span>
                                {eleRef.state.childName}
                                <span className="child-age childage" id="childage">
                                {result.Age}
                                </span>
                            </div>):null
                            )}
                            <div className="M15_42 slide-tag tagkids_1" data-id="1" onClick={(e) => { actions.SlideTag(e,eleRef) }} style={{display: "inline-block"}}>
                            <span className="arrow-icon M14_9e" data-icon-font='<' data-id="1" name="myself" id="myself" value="1"></span>
                            Myself
                            </div>
                        </div>
                    </div>
                )            
            }
        
            <div className="float-field">
                <span className="icon select-all checkbox checkAll" data-icon-font="z" id="setpic" value="0" onClick={(e) => { actions.myProfile_status(e) }}>
                </span>
                <span className="M15_42 check-text">Use this as my profile picture</span>
            </div>
            <div className="choose_photo_btns">
                <label htmlFor={tool=="MB"?"mybumpie_upload":"face_upload"}>
                    <span className={tool=="MB"?"askB_1 upload_btn":"askB_1 choose_btn"}>
                        <span data-icon-font="" className="icon"></span>
                        <span className="B14_white">{tool=="MB"? "Upload Your Bumpie":"Choose Your Photo"}</span>
                    </span>
                </label>
            </div>
            <div className="upload_photo_btns">
                <span className="askB_1 upload_btn" id={tool=="MB"?"add_mybumpie":"add_face"} onClick={()=>{eleRef.UploadPhoto()}}>
                    <span className="B14_white dev_uploadphoto">{tool=="MB"?"Upload Photo":"Upload Face A Day"}</span>
                </span>
                <span className="askB_1 cancle_btn" onClick={()=>{eleRef.CancleButton()}}>
                    <span className="B14_white">Cancel</span>
                </span>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/tools/common/UploadFrame.js